export const iconFontAwesomeConstructionBrush = (
	<i className="fa-solid fa-brush"></i>
);
